/**
 * Per-visit counters for API/network errors and load time.
 * Used by apiClient (on error) and VisitTrackingContext (on page leave) so timeline can show
 * average load time, failed API calls, network errors per visit.
 */

const counters = {
  apiErrorCount: 0,
  networkErrorCount: 0,
  loadTimeMs: 0,
};

export function recordApiError() {
  counters.apiErrorCount += 1;
}

export function recordNetworkError() {
  counters.networkErrorCount += 1;
}

export function setPageLoadTime(ms) {
  if (typeof ms === "number" && ms >= 0) counters.loadTimeMs = ms;
}

export function getAndResetCounters() {
  const snapshot = { ...counters };
  counters.apiErrorCount = 0;
  counters.networkErrorCount = 0;
  counters.loadTimeMs = 0;
  return snapshot;
}
